export enum StorageKeys {
  OnBoardingDone = 'on_boarding_done',
  UserLanguage = 'user_language',
  GeoPermission = 'geo_permission',
  LoggedUser = 'user',
  AccessToken = 'access_token',
  NoRegisterAccess = 'no_register_access'
}
